import React from 'react'
import styled from 'styled-components'

import { Icon, Button } from '.'

const StyledButton = styled(Button)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 0;
    color: white;
    width: 80px !important;
    height: 40px !important;
    font-size: 10px !important;

    ${props => props.type === 'success' && `
        background-color: ${props.theme.colors.success};
    `}

    ${props => props.type === 'error' && `
        background-color: ${props.theme.colors.error};
    `} 
`

const Text = styled.span`
    padding-top: 3px;
`

export const ActionButton = ({type, onClick, children}) => (
    <StyledButton type={type} onClick={onClick}>
        <Icon name={type} />
        <Text>{children}</Text>
    </StyledButton>
)